import React from 'react';

import { formatNumber } from 'js/components/shared/vehicleFunctions';

const VehicleDetails = ({ vehicle, t }) => {
    const renderDetailsItem = (label, content = '--') => (
        <div className="o-layout__item u-1/3 u-1/2@s">
            <p className="u-text-disabled">{label}</p>
            <p>{content}</p>
        </div>
    );
    return (
        <>
            <p className="u-h6 u-mb-small">
                {t.getTraduction('VehicleDetails')}
            </p>
            <div className="o-layout">
                {renderDetailsItem(
                    t.getTraduction('Plate'),
                    vehicle.MoreDetails.Plate
                )}
                {renderDetailsItem(
                    t.getTraduction('VIN'),
                    vehicle?.Frame || vehicle?.VIN
                )}
                {renderDetailsItem(
                    t.getTraduction('Kms'),
                    vehicle.MoreDetails.Kilometers
                        ? formatNumber(vehicle.MoreDetails.Kilometers) + ' Km'
                        : '--'
                )}
                {renderDetailsItem(
                    t.getTraduction('FechaMatriculacion'),
                    vehicle.MoreDetails.RegistrationDate
                )}
                {renderDetailsItem(
                    t.getTraduction('Fuel'),
                    vehicle.MoreDetails.EnergyTypeName
                )}
                {renderDetailsItem(
                    t.getTraduction('Displacement'),
                    vehicle.MoreDetails.Displacement
                        ? formatNumber(vehicle.MoreDetails.Displacement) + ' CC'
                        : '--'
                )}
                {renderDetailsItem(
                    t.getTraduction('NumberDoors'),
                    vehicle.MoreDetails.Doors
                )}
                {renderDetailsItem(
                    t.getTraduction('Power'),
                    vehicle.MoreDetails.HorsePower
                        ? vehicle.MoreDetails.HorsePower + ' CV'
                        : '--'
                )}
                {renderDetailsItem(
                    t.getTraduction('TaxHorsePower'),
                    vehicle.MoreDetails.HorsePowerKW
                        ? vehicle.MoreDetails.HorsePowerKW + ' KW'
                        : '--'
                )}
                {renderDetailsItem(
                    t.getTraduction('ExternalColor'),
                    vehicle.MoreDetails.ColorName
                )}
                {renderDetailsItem(
                    t.getTraduction('InternalColor'),
                    vehicle.MoreDetails.InteriorName
                )}
                {renderDetailsItem(
                    t.getTraduction('CO2Emissions'),
                    vehicle.MoreDetails.Co2
                        ? vehicle.MoreDetails.Co2 + ' g/km'
                        : '--'
                )}
                {renderDetailsItem(
                    'Afectación',
                    vehicle.MoreDetails.AffectationMotorText
                        ? vehicle.MoreDetails.AffectationMotorText
                        : '--'
                )}
            </div>
        </>
    );
};

export default VehicleDetails;
